<template class='container'>
  <div class="map-test">
    <div class="mt-main">
      <div class="mtm-test-1">
        <div class="mtmt-con">
          <div class="mtmtc-box">
            <div class="top-tools">
              <div class="amap-search">
                <div class="as-input">
                  <el-input
                    :placeholder="$t('caa1')"
                    v-model="searchOption.value"
                    size="small"
                    @input="searchInput">
                    <i slot="suffix" class="el-input__icon el-icon-search" v-if="false"></i>
                  </el-input>
                </div>
                <div id="searchPanel">
                  <transition name="el-zoom-in-top">
                    <div class="box-card transition-box"
                         v-show="searchOption.show">
                      <div class="bc-body">
                        <div class="bcb-row"
                             :v-if="searchOption.result.length > 0"
                             v-for="(item, index) in searchOption.result"
                             :key="index"
                             :title="`${item.name}【${item.district}】`"
                             @click="selectPlace(index)">
                          <i class="el-icon-location-outline"></i>
                          <div class="bcb-con">
                            <span class="ellipsis-1">{{item.name}}</span>
                            <span class="ellipsis-1">[{{item.district}}]</span>
                          </div>
                        </div>
                        <p v-if="searchOption.result.length === 0">
                          --- 未搜索到地址信息 ---
                        </p>
                        <div class="bcb-row" v-if="false">
                          <i class="el-icon-location-outline"></i>
                          <div class="bcb-con">
                            <span class="ellipsis-1">梅溪湖创新中心(西南门)</span>
                            <span class="ellipsis-1">[湖南省长沙市岳麓区]</span>
                          </div>
                        </div>
                      </div>
                      <div class="bc-foot">
                        <div class="bcf-close"
                             @click="searchOption.show = false"
                             :title="$t('caa3')">
                          <i class="fa fa-angle-double-up"></i>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
              <div class="map-type">
                <div class="mt-btn" @click="changeMapType">
                  <i :class="mapTypeClass"></i>
                </div>
              </div>
            </div>
            <el-amap class="amap-box" vid="amap-demo"
                     :amap-manager="amapManager"
                     :plugin="plugins"
                     :center="center"
                     :events="events"
                     :resize-enable="resizeEnable"
                     :is-hotspot="isHotspot"
                     :zoom="zoom">
              <el-amap-marker :v-if="markers.data"
                              v-for="(item, index) in markers.data"
                              :position="item.position"
                              :events="item.events"
                              :visible="item.visible"
                              :draggable="item.draggable"
                              :icon="item.icon"
                              :label="item.label"
                              :vid="index" :key="index">
                <coor-dinate :keyDownCtrl="keyDownCtrl"
                             :showDeviceInfo="item.showDeviceInfo"
                             :isAmapSingle="true"></coor-dinate>
              </el-amap-marker>
            </el-amap>
          </div>
          <div class="mtmtc-description">
            <div v-if="markers.data.length > 0" class="mtmtcd-hasdata">
              <p>
                <em>{{$t('caa4')}}:</em>
                <span :title="markers.data[0].address">{{markers.data[0].address}}</span>
              </p>
              <p>
                <span>
                  <em>{{$t('caa5')}}:</em>
                  <span>{{markers.data[0].position[0]}}</span>
                </span>
                <span>
                  <em>{{$t('caa6')}}:</em>
                  <span>{{markers.data[0].position[1]}}</span>
                </span>
              </p>
            </div>
            <p v-else class="mtmtcd-nodata">
              {{$t('caa7')}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import coorDinate from "./child/coordinate";
  import { AMapManager } from 'vue-amap';
  export default {
    data () {
      return {
        amapManager: null,
        center: [121.594, 31.21],
        scrollWheel: true,
        resizeEnable: true,
        isHotspot: true,
        mapStyle: ['normal', 'dark', 'light', 'fresh'],
        zoom: 15,
        events: {
          init: (oaepParams) => {
            console.log(oaepParams, this.dialogTitle === 'EDIT');
            let thisVue = this;
            switch (this.dialogTitle) {
                case 'ADD':
                  this.$nextTick(() => {
                    this.pluginsObj.toolBar.doLocation();
                  });
                  break;
                case 'EDIT':
                  console.log("this.formDialog.lat-------->", this.formDialog);
                  if (!this.formDialog.lat || !this.formDialog.lng) {
                    this.$nextTick(() => {
                      this.pluginsObj.toolBar.doLocation();
                    });
                    break;
                  } else {
                    let markerData = this.constructionMarkerData(thisVue);
                    let lnglat = [this.formDialog.lng, this.formDialog.lat];
                    markerData.position = lnglat;
                    this.center = lnglat;
                    markerData.label = {content: this.formDialog.name, offset: [0, 32]};
                    markerData.address = this.formDialog.formattedaddress;
                    console.log('markerData', markerData, this.formDialog);
                    this.markers.data = [markerData];
                    console.log('init---->', this.markers.data[0]);
                    this.$nextTick(() => {
                      this.getGeocoderAddressData(markerData, lnglat, 'amapData');
                    });
                    break;
                  }
            }
          },
          click: (ev) => {
            let thisVue = this;
            console.log('amap------------->', ev);
            let lnglat = [ev.lnglat.lng, ev.lnglat.lat];
            let markerData = this.constructionMarkerData(thisVue);
            markerData.position = lnglat;
            console.log(markerData.position);
            markerData.label = {content: this.formDialog.name, offset: [0, 32]};
            console.log(markerData, lnglat);
            this.markers.data = [this.getGeocoderAddressData(markerData, lnglat, 'amapData')];
            console.log(this.markers);
          }
        },
        markers: {
          selectedIndex: 0,
          window: null,
          data: [],
          methods: {
            switchCoordinate(infoSelf, thisVue) {
              for (let index in thisVue.markers.data) {
                let marker = thisVue.markers.data[index];
                if (Number(index) === infoSelf.vid) {
                  marker.showDeviceInfo = !marker.showDeviceInfo;
                } else {
                  marker.showDeviceInfo = false;
                }
              }
            }
          }
        },
        searchOption: {
          value: '',
          result: [],
          show: false
        },
        window: null,
        plugins: [
          {
            pName: 'ToolBar',
            locate: true,
            liteStyle: true,
            position: 'LB',
            events: {
              init: (instance) => {
                console.log('ToolBar---------->', instance);
                this.$set(this.pluginsObj, 'toolBar', instance);
                instance.show();
                instance.showLocation();
              }
            }
          },
          {
            pName: 'Geocoder',
            events: {
              init: (instance) => {
                this.$set(this.pluginsObj, 'Geocoder', instance);
              }
            }
          },
          {
            pName: 'Autocomplete',
            events: {
              init: (instance) => {
                console.log('placeSearch-------------------->', instance);
                this.$set(this.pluginsObj, 'autoComplete', instance);
              }
            }
          },
          {
            pName: 'OverView',
            events: {
              init: (instance) => {
                // console.log('placeSearch-------------------->', instance);
                this.$set(this.pluginsObj, 'OverView', instance);
                // instance.on('selectChanged', function (SelectChangeEvent) {
                //     console.log('SelectChangeEvent----------->', SelectChangeEvent);
                // });
              }
            }
          }
        ],
        pluginsObj: {},
        keyDownCtrl: false,
        mapTypeClass: 'map-type-1',
        mapType:null
      };
    },
    props: {
      formDialog: {
        type: Object,
        default() {
          return {};
        }
      },
      dialogTitle: {
        type: String,
        default: 'ADD'
      }
    },
    methods: {
      constructionMarkerData() {
        return {
          position: [121.591, 31.211],
          address: '',
          citycode: '',
          adcode: '',
          init_icon: null,
          icon: 'static/test/coordinate_offline.svg',
          label: {content: '一号设备', offset: [0, 32]},
          showDeviceInfo: false,
          events: {
            init: (o) => {
              let infoSelf = o.w;
              this.markers.data[0].init_icon = infoSelf.icon;
            },
            click: () => {
              // console.log(e);
              // let target = e.target;
              // let infoSelf = target.w;
              // this.markers.methods.switchCoordinate(infoSelf, this);
            },
            dragend: (e) => {
              console.log('---event---: dragend');
              let lnglat = [e.lnglat.lng, e.lnglat.lat];
              this.markers.data[0].position = lnglat;
              this.getGeocoderAddressData(this.markers.data[0], lnglat, 'amapData');
            }
          },
          visible: true,
          draggable: true
        };
      },
      getGeocoderAddressData(data, lnglat, emitName) {
        emitName && this.$emit(emitName, data);
        let vueSelf = this;
        this.pluginsObj.Geocoder.getAddress(lnglat, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            data.address = result.regeocode.formattedAddress;
            data.citycode = result.regeocode.addressComponent.citycode;
            data.adcode = result.regeocode.addressComponent.adcode;
            console.log(vueSelf);
            emitName && vueSelf.$emit(emitName, data);
          }
        });
        return data;
      },
      searchInput(value) {
        console.log(this.pluginsObj);
        this.searchOption.show = true;
        let vueSelf = this;
        this.pluginsObj.autoComplete.search(value, function (status, res) {
          console.log(status, res, status === 'no_data');
          switch (status) {
            case 'complete':
              if (res.info === 'OK') {
                vueSelf.searchOption.result = res.tips;
              } else {
                vueSelf.searchOption.result = [];
              }
              break;
            case 'no_data':
              vueSelf.searchOption.result = [];
              break;
            case 'error':
              res === 'NO_PARAMS'
                ? vueSelf.searchOption.result = []
                : vueSelf.$elementMessage(this.$t('caa9'), 'warning');
              break;
          }
        });
      },
      selectPlace(index) {
        let placeInfo = this.searchOption.result[index];
        if (placeInfo.location) {
          let thisVue = this;
          this.isEdit = false;
          let lnglat = [placeInfo.location.lng, placeInfo.location.lat];
          let markerData = this.constructionMarkerData(thisVue);
          console.log('this.formDialog.name----->', this.formDialog.name);
          markerData.label = {content: this.formDialog.name, offset: [0, 32]};
          markerData.position = lnglat;
          this.markers.data = [markerData];
          // console.log(this.amapData.name.length, markerData);
          thisVue.targetInfo = this.getGeocoderAddressData(markerData, lnglat, 'amapData');
          this.center = lnglat;
          this.zoom = 15;
          this.searchOption.value = placeInfo.name;
        } else {
          this.$elementMessage(this.$t('caa10'), 'warning');
        }
      },
      setDeviceName(n) {
        console.log(n);
        this.markers.data[0] && (this.markers.data[0].label = {content: this.formDialog.name, offset: [0, 32]});
      },
      changeMapType() {
        let defaultType = 0;
        if (this.mapTypeClass === 'map-type-0') {
          this.mapTypeClass = 'map-type-1';
        } else {
          this.mapTypeClass = 'map-type-0';
          defaultType = 1;
        }
        if (this.mapType){
          this.mapType.U2 = defaultType;
        } else {
          this.mapType = new AMap.MapType({
            defaultType: defaultType, // 使用3D地图
            showRoad: true
          });
          this.mapType.hide();
        }
        // mapType.hide();
        this.amapManager._map.addControl(this.mapType);
      }
    },
    created() {
      this.amapManager = new AMapManager();
      document.onkeydown = ev => {
        this.keyDownCtrl = ev.keyCode === 17;
      };
      document.onkeyup = () => {
        this.keyDownCtrl && (this.keyDownCtrl = false);
      };
      console.log('dialogTitle------------>', this.dialogTitle);
    },
    components: {
      coorDinate
    },
    watch: {
      formDialog: {
        deep: true,
        handler: 'setDeviceName'
      }
    }
  };
</script>

<style lang='scss' scoped>
  div,p,span{
    box-sizing: border-box;
  }
  .map-test{
    width: 100%;
    height: 100%;
    /*border: solid 1px #aaa;*/
    .mt-main{
      height: 100%;
      .mtm-test-1{
        height: 100%;
        .mtmt-con{
          /*display: flex;*/
          /*justify-content: center;*/
          /*align-items: center;*/
          height: 100%;
          .mtmtc-box{
            position: relative;
            width: 100%;
            height: calc(100% - 30px);
            padding-bottom: 10px;
            margin-bottom: 6px;
            border-bottom: solid 1px #ddd;
            >>>.search-box{
              position: absolute;
              right: 8px;
              top: 8px;
              width: 50%;
              height: 35px;
              .search-tips{
                max-width: 99.5%;
                ul{
                  overflow-y: auto;
                  max-height: 300px;
                  li{
                    display: -webkit-box;
                    white-space: nowrap;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }
            }
            >>> .amap-box{
              .amap-info-close{
                display: none;
              }
              .amap-info-sharp{
                height: 0 !important;
              }
            }
            .top-tools{
              position: absolute;
              top: 8px;
              right: 8px;
              width: 65%;
              height: 30px;
              z-index: 10000;
              display: flex;
              align-items: center;
              .amap-search{
                position: relative;
                flex-grow: 1;
                #searchPanel{
                  position: absolute;
                  width: 100%;
                  .box-card{
                    background: #fff;
                    border-radius: 5px;
                    overflow: hidden;
                    box-shadow: 0 0 2px -1px #25324a;
                    .bc-body{
                      overflow-y: auto;
                      max-height: 230px;
                      .bcb-row{
                        display: flex;
                        font-size: 14px;
                        align-items: center;
                        padding: 16px 8px;
                        cursor: pointer;
                        transition: all 400ms;
                        &:hover{
                          background: #60a5e9;
                          color: #fff;
                          i{
                            color: #fff;
                          }
                        }
                        i{
                          font-weight: bold;
                          padding-right: 5px;
                          color: #9a9a9a;
                          flex-shrink: 0;
                        }
                        .bcb-con{
                          display: flex;
                          flex-grow: 1;
                          align-items: center;
                          width: 100%;
                          overflow: hidden;
                          span:first-of-type{
                            flex-grow: 1;
                          }
                          span:last-of-type{
                            flex-shrink: 0;
                            padding-left: 6px;
                            max-width: 140px;
                          }
                        }
                      }
                      p{
                        padding: 16px 8px;
                        font-size: 14px;
                        color: #aaa;
                        text-align: center;
                      }
                    }
                    .bc-foot{
                      .bcf-close{
                        padding: 2px 0;
                        text-align: center;
                        color: #3a8ee6;
                        font-size: 16px;
                        border-top: solid 1px #ddd;
                        cursor: pointer;
                        transition: all 400ms;
                        &:hover{
                          background: #3a8ee6;
                          color: #fff;
                        }
                      }
                    }
                  }
                }
              }
              .map-type{
                flex-shrink: 0;
                width: 34px;
                height: 32px;
                padding-left: 4px;
                .mt-btn{
                  width: 100%;
                  height: 100%;
                  border: solid 1px #DCDFE6;
                  border-radius: 4px;
                  background: #fff;
                  display: flex;
                  justify-content: center;
                  cursor: pointer;
                  i{
                    width: 18px;
                    height: 18px;
                    align-self: center;
                  }
                  .map-type-0{
                    background: url("../../assets/images/amap/map-type-0.svg") no-repeat center;
                    background-size: 100%;
                  }
                  .map-type-1{
                    background: url("../../assets/images/amap/map-type-1.svg") no-repeat center;
                    background-size: 100%;
                  }
                }
              }
            }
          }
          .mtmtc-description{
            height: 30px;
            line-height: 30px;
            // padding-bottom: 20px;
            .mtmtcd-hasdata{
              height: 100%;
              padding-left: 3px;
              /*border: solid 1px #ddd;*/
              p{
                height: 50%;
                display: flex;
                align-items: center;
                color: #0d8867;
                &>span{
                  padding-right: 18px;
                }
                &:first-of-type{
                  span{
                    flex-grow: 1;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                    cursor: pointer;
                  }
                }
                &:last-of-type{
                  color: #58c8a9;
                }
                em{
                  flex-shrink: 0;
                  font-style: normal;
                }
              }
            }
            .mtmtcd-nodata{
              display: flex;
              align-items: center;
              height: 100%;
              padding-left: 3px;
              color: #84acdb;
            }
          }
        }
      }
    }
  }
</style>
